import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Row, Container, Button } from 'react-bootstrap';
import ProjEditForm from './ProjEditForm'

class ProjectsDetailApp extends React.Component {
    E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        this.state = {
            formData: {},
            isLoading: true,
            pid: this.props.match.params["id"]
        };

        this.getData(this.state.pid);

        this.getData = this.getData.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    onEdit() {
        this.props.history.push("/proj/edit/" + this.state.pid);
    }

    getData(pid) {
        console.log(pid, this);
        if (!pid) return;

        API.GetProjectByID({
            ty: 1, //0=該帳號下全部專案, 1=單⼀一專案
            pi: pid
        })
            .then(response => {
                console.log(response);
                this.setState({
                    isLoading: false,
                });

                if (response && response.responseData) {
                    if (response.responseData.data) {
                        let proj = response.responseData.data[0];
                        this.setState({ formData: proj });
                    }
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div className="h1 mx-auto text-center my-5">Loading..</div>
            );
        } else {
            return (
                <>
                    <Row className="justify-content-center pt-5">
                        <Col className="col-md-6">
                            <h1>修改專案</h1>
                        </Col>
                        <Col className="col-md-4 text-right">
                            <Button className="m-2" variant="primary" type="button" onClick={this.onEdit}>修改</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-md-10 mx-auto col">
                            <ProjEditForm isDisabled={true} formData={this.state.formData} />
                        </Col>
                    </Row>
                </>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsDetailApp))